import React, { PropTypes } from 'react';
import { RaisedButton, TableBody, Table } from 'material-ui';
import PageInDicatorDots from './page-indicator-dots';
import { or } from 'ramda';

const GenericAcctReasonContainer = props => {
  const {
    title,
    pageDesc,
    boldedTableDesc,
    step,
    numOfIndicatorDots,
    tableInfo,
    onNextClick,
    nextButtonDisabled,
    hideIndicatorDots,
    footer,
    outsideTable,
    minHeight,
    backButtonFunc,
    hideNextButton,
  } = props;

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'inline-block', maxWidth: '640px' }}>
        <h3 style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.87)', fontSize: '38px', marginBottom: title ? '5%' : '' }}>{title}</h3>
        <div style={{ display: 'inline-block', textAlign: 'left' }}>
          <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '24px', lineHeight: '1.2' }}>{pageDesc}</p>
          <p style={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.87)', fontWeight: '600', marginTop: '5%' }}>{boldedTableDesc}</p>
        </div>
        <div style={{ minHeight: minHeight || '' }}>
          {
            outsideTable ? tableInfo :
            <Table>
              <TableBody>
                {tableInfo}
              </TableBody>
            </Table>
          }
        </div>
        <div>
          {
            hideNextButton ? <span/> :
            <RaisedButton
              secondary
              label="NEXT"
              style={{ width: '100px', marginTop: '7%', float: step ? 'right' : '' }}
              disabled={nextButtonDisabled}
              onTouchTap={onNextClick}
              className="nextRaisedButton"
            />
          }
          {
            step ?
            <RaisedButton
              backgroundColor="rgb(232,232,232)"
              label="BACK"
              style={{ width: '100px', marginTop: '7%', float: 'left' }}
              onTouchTap={backButtonFunc}
            /> : <span/>
          }
        </div>
        <div style={{ marginTop: '8%' }}>
          <PageInDicatorDots
            hide={hideIndicatorDots}
            numberOfIndicators={numOfIndicatorDots}
            activeIndicator={step}
          />
        </div>
        {
          or(footer, <span/>)
        }
      </div>
    </div>
  );
};

GenericAcctReasonContainer.propTypes = {
  onNextClick: PropTypes.func,
  step: PropTypes.number,
  numOfIndicatorDots: PropTypes.number,
  hideIndicatorDots: PropTypes.bool,
  nextButtonDisabled: PropTypes.bool,
  title: PropTypes.string,
  pageDesc: PropTypes.string,
  boldedTableDesc: PropTypes.string,
  footer: PropTypes.object,
  outsideTable: PropTypes.bool,
  minHeight: PropTypes.string,
  backButtonFunc: PropTypes.func,
};

export default GenericAcctReasonContainer;



// WEBPACK FOOTER //
// ./src/app/components/signup/generic-page-layout.jsx